import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import BookingPage from "./pages/BookingPage";
import BookingsList from "./pages/BookingsList";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import Login from "./pages/Login";
import AddUser from "./pages/AddUser";
import { VenueConfigProvider } from "./context/VenueConfigContext";
import { AuthProvider } from "./context/AuthContext";
import Reports from "./pages/Reports";
import CustomerLedger from "./pages/reports/CustomerLedger";
import AdvanceBookings from "./pages/reports/AdvanceBookings";
import BookingReport from "./pages/reports/BookingReport";

import AuthGuard from "./components/AuthGuard";
import RoleGuard from "./components/RoleGuard";

function App() {
  return (
    <AuthProvider>
      <VenueConfigProvider>
        <Router>
          <Routes>
            {/* PUBLIC ROUTE */}
            <Route path="/login" element={<Login />} />

            {/* PROTECTED APP */}
            <Route
              path="/*"
              element={
                <AuthGuard>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<BookingPage />} />
                      <Route path="/bookings" element={<BookingsList />} />
                      <Route
  path="/admin/reports"
  element={
    <RoleGuard roles={["admin","manager"]}>
      <Reports />
    </RoleGuard>
  }
/>

<Route
  path="/admin/reports/customer-ledger"
  element={
    <RoleGuard roles={["admin", "manager"]}>
      <CustomerLedger />
    </RoleGuard>
  }
/>

<Route
  path="/admin/reports/advance-bookings"
  element={
    <RoleGuard roles={["admin","manager"]}>
      <AdvanceBookings />
    </RoleGuard>
  }
/>

<Route
  path="/admin/reports/booking-report"
  element={
    <RoleGuard roles={["admin"]}>
      <BookingReport />
    </RoleGuard>
  }
/>

                      <Route
                        path="/admin"
                        element={
                          <RoleGuard roles={["admin", "manager","user"]}>
                            <AdminDashboard />
                          </RoleGuard>
                        }
                      />

                      <Route
                        path="/admin/settings"
                        element={
                          <RoleGuard roles={["admin"]}>
                            <AdminSettings />
                          </RoleGuard>
                        }
                      />
                      <Route
                        path="/admin/settings/add-user"
                        element={
                          <RoleGuard roles={["admin"]}>
                            <AddUser />
                          </RoleGuard>
                        }
                      />
                    </Routes>
                  </Layout>
                </AuthGuard>
              }
            />
          </Routes>
        </Router>
      </VenueConfigProvider>
    </AuthProvider>
  );
}

export default App;
